// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { Box, Anchor, Footer, Tag } from 'grommet'
import PropTypes from 'prop-types'

import { Typography } from '../../../../components'

const FooterComponent = ({ i18nTranslation }) => (
  <Box margin={{ vertical: 'small' }} pad={{ top: 'medium' }}>
    <Footer
      align="center"
      justify="end"
      gap="medium"
      background="#CBFAEB"
      round="medium"
    >
      <Box direction="column" pad="small" gap="xsmall">
        <Box direction="row">
          <Tag
            value={i18nTranslation('global_search.beta_tag')}
            testId="permission-modal-cancel-btn"
            background="green"
            border={false}
            pad={{ vertical: 'none' }}
          />
        </Box>
        <Box gap="xsmall">
          <Typography type="text" size="small">
            {i18nTranslation('global_search.beta_tag_description')}
            <Anchor
              label={i18nTranslation('global_search.beta_tag_link')}
              href="https://hpetraining.co1.qualtrics.com/jfe/form/SV_0i8Bsa17cg6MkCy?env=p&pd=gl&tof=gf"
              target="_blank"
              margin={{ left: 'xsmall' }}
            />
          </Typography>
        </Box>
      </Box>
    </Footer>
  </Box>
)

FooterComponent.propTypes = {
  i18nTranslation: PropTypes.any.isRequired
}

export { FooterComponent }
